export default "__VITE_ASSET__DeptyQuK__"